
export const defaultFattyAcidSets = [
  {id: 4, name: "Cell culture", fattyAcids: [
    {cc: 18, db: 1},
		{cc: 16, db: 1},
		{cc: 18, db: 2},
		{cc: 16, db: 0},
		{cc: 17, db: 1},
		{cc: 20, db: 3},
		{cc: 20, db: 2},
		{cc: 18, db: 0},
		{cc: 22, db: 1},
		{cc: 12, db: 0},
		{cc: 20, db: 4},
		{cc: 16, db: 2},
		{cc: 14, db: 0},
		{cc: 18, db: 3},
		{cc: 20, db: 0},
		{cc: 19, db: 1},
		{cc: 17, db: 0},
		{cc: 28, db: 3},
		{cc: 20, db: 5},
		{cc: 20, db: 1},
  ]},
  {id: 2, name: "Higher Organisms, Heart & Liver", fattyAcids: [
    {cc: 18, db: 2},
		{cc: 18, db: 1},
		{cc: 16, db: 1},
		{cc: 22, db: 2},
		{cc: 18, db: 3},
		{cc: 20, db: 3},
		{cc: 28, db: 4},
		{cc: 20, db: 2},
		{cc: 22, db: 6},
		{cc: 28, db: 3},
		{cc: 16, db: 0},
		{cc: 20, db: 4},
		{cc: 18, db: 0},
		{cc: 22, db: 1},
		{cc: 14, db: 2},
		{cc: 14, db: 0},
		{cc: 17, db: 1},
		{cc: 26, db: 3},
		{cc: 19, db: 1},
		{cc: 26, db: 1},
  ]},
  {id: 3, name: "Higher Organisms, Brain", fattyAcids: [
    {cc: 18, db: 1},
		{cc: 20, db: 4},
		{cc: 22, db: 6},
		{cc: 16, db: 1},
		{cc: 18, db: 2},
		{cc: 16, db: 0},
		{cc: 20, db: 3},
		{cc: 18, db: 4},
		{cc: 20, db: 5},
		{cc: 22, db: 1},
		{cc: 21, db: 0},
		{cc: 23, db: 2},
		{cc: 22, db: 5},
		{cc: 23, db: 1},
		{cc: 20, db: 2},
		{cc: 23, db: 0},
		{cc: 18, db: 0},
		{cc: 26, db: 6},
		{cc: 24, db: 4},
		{cc: 17, db: 4},
  ]},
  {id: 8, name: "Lower Organims", fattyAcids: [
    {cc: 18, db: 2},
		{cc: 18, db: 1},
		{cc: 16, db: 1},
		{cc: 22, db: 6},
		{cc: 20, db: 3},
		{cc: 20, db: 2},
		{cc: 16, db: 0},
		{cc: 20, db: 1},
		{cc: 20, db: 5},
		{cc: 18, db: 3},
		{cc: 22, db: 7},
		{cc: 14, db: 0},
		{cc: 18, db: 4},
		{cc: 21, db: 0},
		{cc: 16, db: 2},
		{cc: 28, db: 4},
		{cc: 26, db: 6},
		{cc: 22, db: 1},
		{cc: 20, db: 4},
		{cc: 28, db: 3},
  ]},
  {id: 5, name: "Fungi", fattyAcids: [
    {cc: 16, db: 1},
		{cc: 18, db: 1},
		{cc: 18, db: 2},
		{cc: 16, db: 0},
		{cc: 18, db: 0},
		{cc: 28, db: 3},
		{cc: 18, db: 3},
		{cc: 12, db: 0},
		{cc: 10, db: 0},
		{cc: 26, db: 3},
		{cc: 16, db: 2},
		{cc: 22, db: 1},
		{cc: 28, db: 4},
		{cc: 22, db: 2},
		{cc: 26, db: 2},
		{cc: 20, db: 4},
		{cc: 17, db: 1},
		{cc: 28, db: 2},
		{cc: 12, db: 1},
		{cc: 20, db: 1},
  ]},
  {id: 6, name: "Plants", fattyAcids: [
    {cc: 18, db: 3},
		{cc: 18, db: 2},
		{cc: 18, db: 1},
		{cc: 28, db: 5},
		{cc: 28, db: 4},
		{cc: 22, db: 3},
		{cc: 16, db: 0},
		{cc: 28, db: 3},
		{cc: 18, db: 0},
		{cc: 22, db: 2},
		{cc: 22, db: 1},
		{cc: 28, db: 6},
		{cc: 26, db: 2},
		{cc: 22, db: 4},
		{cc: 16, db: 1},
		{cc: 18, db: 4},
		{cc: 14, db: 2},
		{cc: 24, db: 5},
		{cc: 24, db: 1},
		{cc: 24, db: 6},
  ]},
  {id: 1, name: "Bacteria", fattyAcids: [
    {cc: 16, db: 0},
		{cc: 18, db: 1},
		{cc: 15, db: 0},
		{cc: 14, db: 0},
		{cc: 16, db: 1},
		{cc: 17, db: 0},
		{cc: 17, db: 1},
		{cc: 20, db: 1},
		{cc: 19, db: 1},
		{cc: 18, db: 2},
		{cc: 18, db: 0},
		{cc: 19, db: 0},
		{cc: 20, db: 0},
		{cc: 15, db: 1},
		{cc: 22, db: 1},
		{cc: 22, db: 0},
		{cc: 26, db: 3},
		{cc: 27, db: 3},
		{cc: 26, db: 2},
		{cc: 28, db: 3},
  ]},
  {id: 7, name: "All fatty acids", fattyAcids: [
    {cc: 10, db: 0},
		{cc: 10, db: 1},
		{cc: 12, db: 0},
		{cc: 12, db: 1},
		{cc: 13, db: 0},
		{cc: 13, db: 1},
		{cc: 14, db: 0},
		{cc: 14, db: 1},
		{cc: 14, db: 2},
		{cc: 15, db: 0},
		{cc: 15, db: 1},
		{cc: 15, db: 2},
		{cc: 16, db: 0},
		{cc: 16, db: 1},
		{cc: 16, db: 2},
		{cc: 16, db: 3},
		{cc: 16, db: 4},
		{cc: 17, db: 0},
		{cc: 17, db: 1},
		{cc: 17, db: 2},
		{cc: 17, db: 3},
		{cc: 17, db: 4},
		{cc: 18, db: 0},
		{cc: 18, db: 1},
		{cc: 18, db: 2},
		{cc: 18, db: 3},
		{cc: 18, db: 4},
		{cc: 18, db: 5},
		{cc: 18, db: 6},
		{cc: 19, db: 0},
		{cc: 19, db: 1},
		{cc: 19, db: 2},
		{cc: 19, db: 3},
		{cc: 19, db: 4},
		{cc: 19, db: 5},
		{cc: 19, db: 6},
		{cc: 20, db: 0},
		{cc: 20, db: 1},
		{cc: 20, db: 2},
		{cc: 20, db: 3},
		{cc: 20, db: 4},
		{cc: 20, db: 5},
		{cc: 20, db: 6},
		{cc: 21, db: 0},
		{cc: 21, db: 1},
		{cc: 21, db: 2},
		{cc: 21, db: 3},
		{cc: 21, db: 4},
		{cc: 21, db: 5},
		{cc: 21, db: 6},
		{cc: 22, db: 0},
		{cc: 22, db: 1},
		{cc: 22, db: 2},
		{cc: 22, db: 3},
		{cc: 22, db: 4},
		{cc: 22, db: 5},
		{cc: 22, db: 6},
		{cc: 22, db: 7},
		{cc: 22, db: 8},
		{cc: 23, db: 0},
		{cc: 23, db: 1},
		{cc: 23, db: 2},
		{cc: 23, db: 3},
		{cc: 23, db: 4},
		{cc: 23, db: 5},
		{cc: 23, db: 6},
		{cc: 23, db: 7},
		{cc: 23, db: 8},
		{cc: 24, db: 0},
		{cc: 24, db: 1},
		{cc: 24, db: 2},
		{cc: 24, db: 3},
		{cc: 24, db: 4},
		{cc: 24, db: 5},
		{cc: 24, db: 6},
		{cc: 24, db: 7},
		{cc: 24, db: 8},
		{cc: 25, db: 0},
		{cc: 25, db: 1},
		{cc: 25, db: 2},
		{cc: 25, db: 3},
		{cc: 25, db: 4},
		{cc: 25, db: 5},
		{cc: 25, db: 6},
		{cc: 25, db: 7},
		{cc: 25, db: 8},
		{cc: 26, db: 0},
		{cc: 26, db: 1},
		{cc: 26, db: 2},
		{cc: 26, db: 3},
		{cc: 26, db: 4},
		{cc: 26, db: 5},
		{cc: 26, db: 6},
		{cc: 26, db: 7},
		{cc: 26, db: 8},
		{cc: 27, db: 0},
		{cc: 27, db: 1},
		{cc: 27, db: 2},
		{cc: 27, db: 3},
		{cc: 27, db: 4},
		{cc: 27, db: 5},
		{cc: 27, db: 6},
		{cc: 27, db: 7},
		{cc: 27, db: 8},
		{cc: 28, db: 0},
		{cc: 28, db: 1},
		{cc: 28, db: 2},
		{cc: 28, db: 3},
		{cc: 28, db: 4},
		{cc: 28, db: 5},
		{cc: 28, db: 6},
		{cc: 28, db: 7},
		{cc: 28, db: 8},
  ]},
]
